import type { FormulaField, FormulaValue, HighLightConditions } from '@lighthouse/core'
import React, { useMemo } from 'react'
import styled from 'styled-components'

import { CURRENT_USER } from '../../constants'
import { useApplicationContext } from '../../contexts'
import { innerOverview } from './InnerTypeRender'

interface FormulaValuePreviewerProps {
    field: FormulaField
    data?: FormulaValue
    width?: number
    isWrap?: boolean
    isBold?: boolean
    styleConditions?: HighLightConditions
    isHasCurrentUser?: boolean
}

const SCxFormula = styled.div<{ isWrap: boolean; isBold?: boolean }>`
    position: relative;
    width: 100%;
    white-space: ${({ isWrap }) => (isWrap ? 'normal' : 'nowrap')};
    font-weight: ${({ isBold }) => (isBold ? 'bold' : 'normal')};
    word-break: break-word;
    overflow: hidden;
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: ${({ isWrap }) => (isWrap ? 'wrap' : 'nowrap')};
    justify-content: flex-start;
    line-height: 24px;
`

export const FormulaValuePreviewer: React.FC<FormulaValuePreviewerProps> = ({
    field,
    data,
    width = 160,
    isWrap = true,
    isBold,
    styleConditions,
    isHasCurrentUser
}) => {
    const { roleOptions, personOptions: appPersonOptions, departmentOptions } = useApplicationContext()
    const personOptions = useMemo(
        () => (isHasCurrentUser ? [CURRENT_USER, ...appPersonOptions] : appPersonOptions),
        [appPersonOptions, isHasCurrentUser]
    )
    const { innerType, id } = field

    const formulaRender = useMemo(() => {
        if (!innerType) {
            return
        }
        return innerOverview(field, data, innerType, width, personOptions, isWrap, isBold)
    }, [data, field, innerType, isBold, isWrap, personOptions, width])

    return (
        <SCxFormula isWrap={isWrap} isBold={isBold}>
            {formulaRender}
        </SCxFormula>
    )
}
